/**
 * @file: 设置cube字段值
 * @author: xiaolong.huang@dmall.com
 */

import Config from '../config/index';
import * as Utils from '../utils/util';
import { getCubeType } from './cubeType';
import { findByCubeId } from './baseQuery';

export function setCubeValue(cube: CubeNode, updateTask: FreeObjMap): any {
    let cubeType: string = getCubeType(cube);

    for (let key in updateTask) {
        let value: any = updateTask[key];

        if (['posX', 'posY', 'posZ'].includes(key)) {
            value = Number(value) || 0;
        }

        switch (cubeType) {
            case 'freezer':
            case 'shelf':
                // 设置架字段
                setShelfCubeKey(cube, key, value);
                break;

            case 'sketchpad':
                // 设置画布字段值
                setSketchpadCubeKey(cube, key, value);
                break;

            case 'cabinet':
            case 'roof':
            case 'beam':
            case 'layer':
            case 'dishrack':
                // 取层板字段值
                setLayerCubeKey(cube, key, value);
                break;

            case 'goods':
            case 'bafflePlate':
            case 'textarea':
                // 设置商品字段值
                setGoodsCubeKey(cube, key, value);
                break;
            default:
                return null;
        }
    }
}

export function setCubeValueById(cubeId: string, updateTask: FreeObjMap): void {
    let targetCube: CubeNode = findByCubeId(cubeId);

    setCubeValue(targetCube, updateTask);
}

// 设置架字段
function setShelfCubeKey(cube: FreeObjMap, key: string, value: any): any {
    // 先取隐射关系
    let shelfKeyMap: ShelfKeyMap = Config.get({
        moduleName: 'shelf',
        key: 'keyMap'
    });

    // key没申明，直接返回 undefined
    if (!Utils.hasKey(shelfKeyMap, key)) {
        return undefined;
    }

    Utils.setMapValueByStringKey(cube, shelfKeyMap[key], value);
}

// 设置画布字段值
function setSketchpadCubeKey(cube: FreeObjMap, key: string, value: any): any {
    // 先取隐射关系
    let sketchpadKeyMap: SketchpadKeyMap = Config.get({
        moduleName: 'sketchpad',
        key: 'keyMap'
    });

    // key没申明，直接返回 undefined
    if (!Utils.hasKey(sketchpadKeyMap, key)) {
        return undefined;
    }

    Utils.setMapValueByStringKey(cube, sketchpadKeyMap[key], value);
}

// 设置层板字段值
function setLayerCubeKey(cube: FreeObjMap, key: string, value: any): any {
    // 先取隐射关系
    let layerKeyMap: LayerKeyMap = Config.get({
        moduleName: 'layer',
        key: 'keyMap'
    });

    // key没申明，直接返回 undefined
    if (!Utils.hasKey(layerKeyMap, key)) {
        return undefined;
    }

    Utils.setMapValueByStringKey(cube, layerKeyMap[key], value);
}

// 设置商品字段值
function setGoodsCubeKey(cube: FreeObjMap, key: string, value: any): any {
    // 先取隐射关系
    let baseKeyMap: GoodsKeyMap = Config.get({
        moduleName: 'goods',
        key: 'keyMap'
    });
    let goodsKeyMap: GetFromGoodsKeyMap = Config.get({
        moduleName: 'goods',
        key: 'getFromGoodsKeyMap'
    });

    // key没申明，直接返回 undefined
    if (!Utils.hasKey(baseKeyMap, key)
        && !Utils.hasKey(goodsKeyMap, key)) {
        return undefined;
    }

    if (Utils.hasKey(goodsKeyMap, key)) {
        return Utils.setMapValueByStringKey(cube, goodsKeyMap[key], value);
    }

    Utils.setMapValueByStringKey(cube, baseKeyMap[key], value);
}
